import { useState, type SyntheticEvent } from 'react'

import { Button, Sheet } from '../../components/ui'
import { CARAVAN_TRIP } from '../../config/trip'
import { tripLocalInstant } from '../../domain/tripTime'

export type PreparedSurprise = {
  teaser: string
  scheduledFor: string
  secretTitle: string
}

export function SurpriseEditor({ onClose, onPrepared }: { onClose: () => void; onPrepared: (surprise: PreparedSurprise) => Promise<void> }) {
  const [teaser, setTeaser] = useState('Une halte se prépare…')
  const [date, setDate] = useState<string>(CARAVAN_TRIP.startsOn)
  const [time, setTime] = useState('20:30')
  const [secretTitle, setSecretTitle] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  async function submit(event: SyntheticEvent<HTMLFormElement>): Promise<void> {
    event.preventDefault()
    if (!secretTitle.trim()) return
    setSaving(true)
    setError('')
    try {
      await onPrepared({ teaser: teaser.trim(), scheduledFor: tripLocalInstant(date, time), secretTitle: secretTitle.trim() })
      onClose()
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : 'La surprise n’a pas pu être enregistrée.')
      setSaving(false)
    }
  }

  return (
    <Sheet title="Préparer une surprise" onClose={onClose}>
      <form className="event-form" onSubmit={(event) => void submit(event)}>
        <p className="privacy-note">L’accroche sera visible par tout le monde. Le détail restera visible uniquement par toi jusqu’à la révélation.</p>
        <label htmlFor="surprise-teaser">Accroche</label>
        <input id="surprise-teaser" maxLength={240} value={teaser} onChange={(event) => setTeaser(event.target.value)} />
        <label htmlFor="surprise-date">Date</label>
        <input id="surprise-date" min={CARAVAN_TRIP.startsOn} max={CARAVAN_TRIP.endsOn} type="date" value={date} onChange={(event) => setDate(event.target.value)} />
        <label htmlFor="surprise-time">Heure de révélation</label>
        <input id="surprise-time" type="time" value={time} onChange={(event) => setTime(event.target.value)} />
        <label htmlFor="surprise-secret">Détail secret</label>
        <input id="surprise-secret" maxLength={160} required value={secretTitle} onChange={(event) => setSecretTitle(event.target.value)} />
        {error ? <p role="alert">{error}</p> : null}
        <Button disabled={saving} fullWidth type="submit">{saving ? 'Enregistrement…' : 'Programmer la surprise'}</Button>
      </form>
    </Sheet>
  )
}
